import { Component } from '@angular/core';

@Component({
    template: `
        An update to the CASLink App is available.
  `
})
export class NewVersionAvailableMessageComponent {
}
